var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _c("p", {
          staticClass: "icon-jujue closeBtn",
          on: { click: _vm.routerBack },
        }),
      ]),
      _c(
        "div",
        { staticClass: "content_box" },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "5px 0" } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QUALITY_DEFECT_SAVE,
                      expression: "QUALITY_DEFECT_SAVE",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onSave },
                },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QUALITY_DEFECT_SUBMIT,
                      expression: "QUALITY_DEFECT_SUBMIT",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit("submit")
                    },
                  },
                },
                [_vm._v("提交")]
              ),
              _vm.detailForm.stinvLink
                ? _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.stinvUrl },
                    },
                    [_vm._v("STINV链接")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "within_box" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "form_box" },
              [
                _c(
                  "el-form",
                  {
                    ref: "detailForm",
                    attrs: {
                      model: _vm.detailForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "主动报废编号",
                                  prop: "sroCode",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.sroCode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "sroCode", $$v)
                                    },
                                    expression: "detailForm.sroCode",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "报废启动日期",
                                  prop: "startDate",
                                },
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: "date",
                                    "value-format": "yyyy-MM-dd",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.detailForm.startDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "startDate", $$v)
                                    },
                                    expression: "detailForm.startDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "报废项目简介",
                                  prop: "projectSummary",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.detailForm.projectSummary,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.detailForm,
                                        "projectSummary",
                                        $$v
                                      )
                                    },
                                    expression: "detailForm.projectSummary",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "已结案", prop: "isClosed" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请选择",
                                    },
                                    model: {
                                      value: _vm.detailForm.isClosed,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.detailForm,
                                          "isClosed",
                                          $$v
                                        )
                                      },
                                      expression: "detailForm.isClosed",
                                    },
                                  },
                                  _vm._l(
                                    _vm.isClosedLists,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "SR等级", prop: "grade" } },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    table: "TT_QUALITY_DEFECT",
                                    field: "GRADE",
                                  },
                                  model: {
                                    value: _vm.detailForm.grade,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "grade", $$v)
                                    },
                                    expression: "detailForm.grade",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发起人", prop: "creator" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.creator,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "creator", $$v)
                                    },
                                    expression: "detailForm.creator",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "状态", prop: "status" } },
                              [
                                _c("ic-select", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: "",
                                    table: "TT_QUALITY_DEFECT",
                                    field: "STATUS",
                                  },
                                  model: {
                                    value: _vm.detailForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "status", $$v)
                                    },
                                    expression: "detailForm.status",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "原因", prop: "reason" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.reason,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "reason", $$v)
                                    },
                                    expression: "detailForm.reason",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "备注", prop: "remarks" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                    autosize: { minRows: 4, maxRows: 6 },
                                    placeholder: "请输入内容",
                                  },
                                  model: {
                                    value: _vm.detailForm.remarks,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "remarks", $$v)
                                    },
                                    expression: "detailForm.remarks",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "是否下发成功",
                                  prop: "isIssued",
                                },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.isIssued,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "isIssued", $$v)
                                    },
                                    expression: "detailForm.isIssued",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "下发时间", prop: "issueDate" },
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "100%" },
                                  attrs: { disabled: "" },
                                  model: {
                                    value: _vm.detailForm.issueDate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.detailForm, "issueDate", $$v)
                                    },
                                    expression: "detailForm.issueDate",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "tab_box" },
            [
              _c(
                "el-tabs",
                {
                  attrs: { type: "border-card" },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      staticClass: "setLength",
                      attrs: { label: "产品明细", name: "tab1" },
                    },
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "margin-bottom": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.onAdd },
                            },
                            [_vm._v("新增")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "danger" },
                              on: {
                                click: function ($event) {
                                  return _vm.onDel("Save")
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.onCopy("Save")
                                },
                              },
                            },
                            [_vm._v("复制行")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "ux-grid",
                        {
                          ref: "plxTable1",
                          attrs: {
                            data: _vm.tabData1,
                            "keep-source": "",
                            "max-height": "500",
                            "show-overflow": "tooltip",
                            "highlight-current-row": "",
                          },
                          on: { "selection-change": _vm.selectionChange },
                        },
                        [
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              type: "checkbox",
                              width: "80",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "操作",
                              width: "80",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onModify(
                                              scope.row,
                                              scope
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("编辑")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "序号",
                              type: "index",
                              width: "60",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "产品编号",
                              field: "eightBitCode",
                              "min-width": "100",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "产品名称",
                              field: "eightBitCodeName",
                              "min-width": "100",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "结算单位名称",
                              field: "supplierName",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "Facility名称",
                              field: "facilityName",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "包装类型",
                              field: "packType",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.packType,
                                            "TT_QUALITY_DEFECT",
                                            "PACK_TYPE"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "生产日期",
                              field: "madeDate",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "批次号",
                              field: "batchNo",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "DCs",
                              field: "dcCode",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", { staticClass: "newDcs" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dcsFilter")(
                                              scope.row.dcCode
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "Markets",
                              field: "marketName",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", { staticClass: "newDcs" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("dcsFilter")(
                                              scope.row.marketName
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "报废范围",
                              field: "disposalScope",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.disposalScope,
                                            "TT_QUALITY_DEFECT",
                                            "DISPOSAL_SCOPE"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "餐厅报废数量(箱)",
                              field: "storeDisposalQty",
                              "min-width": "150",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "DC报废数量(箱)",
                              field: "dcDisposalQty",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "报废数量(箱)",
                              field: "disposalQty",
                              "min-width": "120",
                            },
                          }),
                          _c("ux-table-column", {
                            attrs: {
                              align: "center",
                              title: "处理结果",
                              field: "handlingResult",
                              "min-width": "120",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("ic")(
                                            scope.row.handlingResult,
                                            "TT_QUALITY_DEFECT",
                                            "HANDLING_RESULT"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "门店报废统计", name: "tab2" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plxTable1",
                          attrs: {
                            data: _vm.tabData2,
                            "keep-source": "",
                            "max-height": "500",
                            "show-overflow": "tooltip",
                            "highlight-current-row": "",
                          },
                          on: { "selection-change": _vm.selectionChange },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              type: "checkbox",
                              width: "80",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "序号",
                              type: "index",
                              width: "60",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "产品编号",
                              prop: "eightBitCode",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "产品名称",
                              prop: "eightBitCodeName",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "生产日期",
                              prop: "madeDate",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "批次号",
                              prop: "batchNo",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "DC",
                              prop: "dcCode",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "涉及Markets",
                              prop: "marketName",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "报废数量(箱)",
                              prop: "disposalQty",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "附件上传", name: "tab3" } },
                    [
                      _c(
                        "el-row",
                        { staticStyle: { "margin-bottom": "5px" } },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.onUpload },
                            },
                            [_vm._v("上传")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          ref: "plxTable2",
                          attrs: {
                            data: _vm.tabData3,
                            "max-height": "500",
                            border: "",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作",
                              width: "80",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delFile(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "附件名称",
                              prop: "documentName",
                              "show-overflow-tooltip": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onDownload(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(scope.row.documentName))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "附件描述",
                              prop: "docComments",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "上传人",
                              prop: "userName",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "上传时间",
                              prop: "createDate",
                              "show-overflow-tooltip": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "操作日志", name: "tab4" } },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "plxTable3",
                          attrs: {
                            data: _vm.tabData4,
                            "max-height": "500",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作时间",
                              prop: "createDate",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作人",
                              prop: "operatorName",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              align: "center",
                              label: "操作描述",
                              prop: "action",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "产品明细",
            visible: _vm.dialogEditVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogEditVisible = $event
            },
            close: _vm.onCancel,
          },
        },
        [
          _vm.dialogEditVisible
            ? _c(
                "el-form",
                { ref: "editFormDialog", attrs: { model: _vm.editForm } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "editDataRef",
                      staticClass: "stockRecovery_table",
                      attrs: {
                        data: _vm.editForm.editData,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "eightBitCode",
                          label: "产品编号",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "eightBitCodeName",
                          label: "产品名称",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "supplierName",
                          label: "结算单位名称",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "facilityName",
                          label: "Facility名称",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "packType", label: "包装类型" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: `editData.${scope.$index}.packType`,
                                        rules: _vm.packTypeRules(
                                          scope.$index,
                                          scope.row
                                        ),
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          table: "TT_QUALITY_DEFECT",
                                          field: "PACK_TYPE",
                                        },
                                        model: {
                                          value: scope.row.packType,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "packType", $$v)
                                          },
                                          expression: "scope.row.packType",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3453384238
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "madeDate", label: "生产日期" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: `editData.${scope.$index}.madeDate`,
                                        rules: _vm.madeDateRules(
                                          scope.$index,
                                          scope.row
                                        ),
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "date",
                                          "value-format": "yyyy-MM-dd",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: scope.row.madeDate,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "madeDate", $$v)
                                          },
                                          expression: "scope.row.madeDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3625264339
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "batchNo",
                          label: "批次号",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.clickBatch(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("列表维护")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3489807436
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "disposalScope", label: "报废范围" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: `editData.${scope.$index}.disposalScope`,
                                        rules: _vm.disposalScopeRules(
                                          scope.$index,
                                          scope.row
                                        ),
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          table: "TT_QUALITY_DEFECT",
                                          field: "DISPOSAL_SCOPE",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.recoveryScopeChange(
                                              scope.row,
                                              $event
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.disposalScope,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "disposalScope",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.disposalScope",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3137447936
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "storeDisposalQty",
                          label: "餐厅报废数量(箱)",
                          "min-width": "120",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: `editData.${scope.$index}.restaurantRecoveryQty`,
                                        rules: _vm.restaurantRecoveryQtyRules(
                                          scope.$index,
                                          scope.row
                                        ),
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { disabled: "" },
                                        model: {
                                          value: scope.row.storeDisposalQty,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "storeDisposalQty",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.storeDisposalQty",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          889705061
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "dcDisposalQty",
                          label: "DC报废数量(箱)",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: `editData.${scope.$index}.dcDisposalQty`,
                                        rules:
                                          scope.row.disposalScope == "DC" ||
                                          scope.row.disposalScope ==
                                            "DCAndRestaurant"
                                            ? _vm.dcDisposalQtyRules(
                                                scope.$index,
                                                scope.row
                                              )
                                            : "",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          disabled:
                                            scope.row.disposalScope ==
                                            "Restaurant"
                                              ? true
                                              : false,
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.getDisposalQty(scope.row)
                                          },
                                        },
                                        model: {
                                          value: scope.row.dcDisposalQty,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "dcDisposalQty",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.dcDisposalQty",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1987882135
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "disposalQty", label: "报废数量(箱)" },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "handlingResult",
                          label: "处理结果",
                          "render-header": _vm.renderHeader,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop: `editData.${scope.$index}.handlingResult`,
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          table: "TT_QUALITY_DEFECT",
                                          field: "HANDLING_RESULT",
                                        },
                                        model: {
                                          value: scope.row.handlingResult,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "handlingResult",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.handlingResult",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3410044227
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCancel } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "附件上传",
            visible: _vm.dialogUploadVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogUploadVisible = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _vm.dialogUploadVisible
            ? _c(
                "el-form",
                {
                  ref: "uploadForm",
                  attrs: {
                    model: _vm.uploadForm,
                    rules: _vm.rules,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "附件描述", prop: "docComments" },
                            },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.uploadForm.docComments,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.uploadForm, "docComments", $$v)
                                  },
                                  expression: "uploadForm.docComments",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 20 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "附件名称", prop: "fileName" } },
                            [
                              _c("el-input", {
                                attrs: { readonly: "" },
                                model: {
                                  value: _vm.uploadForm.fileName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.uploadForm, "fileName", $$v)
                                  },
                                  expression: "uploadForm.fileName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              attrs: {
                                name: "file",
                                "on-change": _vm.handleChange,
                                action: "",
                                "http-request": _vm.httpRequest,
                                limit: 1,
                                "show-file-list": false,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                { attrs: { size: "small", type: "primary" } },
                                [_vm._v("选取文件")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "center" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.submitUpload },
                        },
                        [_vm._v("上传")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.onCloseFileDialog },
                        },
                        [_vm._v("关闭")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批次号维护",
            visible: _vm.batchVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchVisible = $event
            },
            close: _vm.onCancel1,
          },
        },
        [
          _vm.batchVisible
            ? _c(
                "el-form",
                { ref: "editForm", attrs: { model: _vm.editForm } },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "center" } },
                    [
                      _c(
                        "el-col",
                        { staticClass: "rowCenter", attrs: { span: 12 } },
                        [_vm._v("显示")]
                      ),
                      _c(
                        "el-col",
                        { staticClass: "rowCenter", attrs: { span: 12 } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.batchShowStatus,
                                callback: function ($$v) {
                                  _vm.batchShowStatus = $$v
                                },
                                expression: "batchShowStatus",
                              },
                            },
                            _vm._l(_vm.batchOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      ref: "editDataRef",
                      staticClass: "stockRecovery_table",
                      attrs: {
                        data: _vm.batchList,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            "show-overflow-tooltip": "",
                            prop: "eightBitCode",
                            label: "产品编号",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { color: "red" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delBatch(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4023931613
                          ),
                        },
                        [
                          _c(
                            "template",
                            { slot: "header" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: { click: _vm.addBatch },
                                },
                                [_vm._v("新增")]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          prop: "batchNo",
                          label: "批次号",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-input", {
                                    attrs: { placeholder: "请输入内容" },
                                    model: {
                                      value: scope.row.batchNo,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "batchNo", $$v)
                                      },
                                      expression: "scope.row.batchNo",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2828441696
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            {
              staticStyle: { "margin-top": "10px" },
              attrs: { type: "flex", justify: "center" },
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onCancel1 } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onConfirm1 } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "产品名称选择",
            visible: _vm.dialogProVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogProVisible = $event
            },
            close: _vm.onClosePro,
          },
        },
        [_c("selProDialog", { on: { setSelPro: _vm.setSelPro } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title_box" }, [
      _c("p", { staticClass: "line" }),
      _c("p", { staticClass: "title" }, [_vm._v("Case Detail")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }